import React from 'react';
import Step0PlanningMode from './Step0PlanningMode';
import PlanningHorizon from './PlanningHorizon';
import Step2SequenceSelection from './Step2SequenceSelection';
import BatchCreation from './BatchCreation';
import Step4Review from './Step4Review';
// Step2aIntermediateProductOrders stays in the repository, but is currently no longer part of
// the wizard pipeline - intermediate product quantities are now entered in the PlanningHorizon
// 'intermediate products' tab. For reactivation see memory/project_intermediate_simplification_2026-04-29.md

export type Step0PropsFromContext = {
  planningMode?: 'NEW_PLANNING' | 'CONTINUATION' | 'REPLANNING';
  selectedMode?: 'NEW_PLANNING' | 'CONTINUATION' | 'REPLANNING';
  onPlanningModeSelect?: (mode: 'NEW_PLANNING' | 'CONTINUATION' | 'REPLANNING') => void;
  sourceScheduleUuid?: string | null;
  frozenZoneEnd?: string | null;
};

interface WizardStepRendererProps {
  currentStep: number;
  step0PlanningMode?: Step0PropsFromContext;
}

const WizardStepRenderer: React.FC<WizardStepRendererProps> = ({ currentStep, step0PlanningMode }) => {
  const step = (() => {
    switch (currentStep) {
      case 0:
        return <Step0PlanningMode {...step0PlanningMode} />;
      case 1:
        return <PlanningHorizon />;
      case 2:
        return <Step2SequenceSelection />;
      case 3:
        return <BatchCreation />;
      case 4:
        return <Step4Review />;
      default:
        return null;
    }
  })();
  return <div className="flex-1 min-h-0 flex flex-col">{step}</div>;
};

export default WizardStepRenderer;
